export default __webpack_public_path__ + "img/image-upload.658c600c.svg";